import { render, staticRenderFns } from "./MessageBoxVue2.vue?vue&type=template&id=2f3c806c&scoped=true"
import script from "./MessageBoxVue2.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoxVue2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageBoxVue2.vue?vue&type=style&index=0&id=2f3c806c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c806c",
  null
  
)

export default component.exports